import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalOptions, ModalController, LoadingController } from 'ionic-angular';
import {DomSanitizer} from '@angular/platform-browser';
import {BusquedaPage} from '../../pages/busqueda/busqueda'

import {AutoCompleteComponent} from 'ionic2-auto-complete';
import { DocumentoServiceProvider } from '../../providers/documento-service/documento-service';
import { AuthServiceProvider } from '../../providers/auth-service/auth-service';
/**
 * Generated class for the DocumentoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-documento',
  templateUrl: 'documento.html',
})
export class DocumentoPage {

  @ViewChild('documento') documento: AutoCompleteComponent
  objdocumento:any;  
  loading: any;
  detalleBusqueda: any;
  carpetas:any=[];

  idtusuario=0;
  namepage = "Administración de documentos";
  iddocumento=0;
  idtipo = 1;

  pagina: string = "vista";
  constructor(public navCtrl: NavController, public navParams: NavParams, public loadingCtrl: LoadingController, 
  	public sanitizer: DomSanitizer, public auth:AuthServiceProvider,
  	public modalCtrl: ModalController,public documentoService: DocumentoServiceProvider) {

  	this.idtusuario = auth.usuario['idtusuario'];

  	console.log(this.idtusuario)
  	this.iddocumento = 0;
  	this.idtipo = 1;
  	this.objdocumento={ id:0, idempresa:1, descripcion:'', observacion:'', idtipo:0, url:'', iddocumento:0, disponible:true , idestado:0 };

  	if (this.navParams.data.archivo != undefined){
  		this.pagina="documento";
  		this.objdocumento = this.navParams.data.archivo;
  		this.iddocumento = this.objdocumento.iddocumento;
  		console.log(this.objdocumento)
  	}
  	else if (this.navParams.data.iddocumento != undefined && this.navParams.data.iddocumento > 0){
  		this.iddocumento = this.navParams.data.iddocumento;
  		this.namepage = this.navParams.data.documento;
  		this.idtipo = 0;

  		this.pagina = "vista";
  	}
  }

  urlpdf() {
    var ddd = this.sanitizer.bypassSecurityTrustResourceUrl(this.objdocumento.url);
    return ddd;
  }

  ionViewDidLoad() {
  	this.cargarCarpetas();

  }

  cargarDocumentos(item){
  	if (item.idtipo == 1)
  		this.navCtrl.push(DocumentoPage, {documento: item.descripcion, iddocumento: item.id, idtipo: item.idtipo})
  	else {

  		//const myModalOptions: ModalOptions = {
        	//enableBackdropDismiss: false,
      	//  cssClass : 'producto'
      	//}

		//let modal = this.modalCtrl.create(DocumentoPage, {'archivo':item}, myModalOptions);
		//modal.present();

  		window.open(item.url, "_blank")
  	}
  }

  botonNuevo(){
  	this.objdocumento.id=0;
  	this.objdocumento.idempresa=1;
  	this.objdocumento.descripcion='';
  	this.objdocumento.observacion='';
  	this.objdocumento.idtipo=0;
  	this.objdocumento.url='';
  	this.objdocumento.iddocumento=0;
  	this.objdocumento.disponible=true;
  	this.objdocumento.idestado=0;
  	this.documento.setValue("");
  }

  botonGrabar(){
  	this.documentoService.guardar(this.objdocumento).then((result) => 
  	{
  		//console.log(result);
  		this.showLoader('Se guardó correctamente!!',1000);
  		this.botonNuevo();
  		
 	 }, (err) => {
    	console.log(err);
    	alert(err);
  	 });
  }

  botonBuscar(){
  	this.documentoService.buscar(-1, 0).then((result) => {
  		this.detalleBusqueda={'parametro':result, 'campobus':'tipo,descripcion,observacion,documentop,disponible'};
  		let myModal = this.modalCtrl.create(BusquedaPage,this.detalleBusqueda);
  		myModal.onDidDismiss(data => {
        if (data != null) {
      		this.objdocumento=data;
      		this.documento.setValue(this.objdocumento.documentop);
        }
  		});
    	myModal.present();
  	},
  	(err) => {
  		console.log(err);
  	});	
  }

  seleccionarDocumentoPadre(evento)
  {
  	this.documento.setValue(evento.descripcion);
  	this.objdocumento.iddocumento = evento.id;
  }

  segmentChanged(event){
    if(event.value == "vista"){
      this.cargarCarpetas();
    }
  }

  cargarCarpetas(){
  	let loading = this.loadingCtrl.create({
		content: 'Cargando, espere por favor...'
	});
	loading.present();

	this.documentoService.buscar(this.iddocumento, this.idtipo).then(val => {
		this.carpetas = val;
		console.log(val)
		loading.dismiss();
	})
  }

  showLoader(mensaje,tiempo){
 
        this.loading = this.loadingCtrl.create({
            content: mensaje,
            duration: tiempo,
            spinner: 'hide'
        });
 
        this.loading.present();

       this.loading.onDidDismiss(() => {
          
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/documento/documento.ts